import { HIDE_ACTION_INDICATOR, SHOW_ACTION_INDICATOR } from '../actions';

export default function(state = {}, action) {
  switch (action.type) {
  case HIDE_ACTION_INDICATOR: {
    return reduceShowState(state, action.key, false);
  }
  case SHOW_ACTION_INDICATOR: {
    return reduceShowState(state, action.key, true);
  }
  default: {
    return state;
  }
  }
}

function reduceShowState(state, key, show) {
  const entry = state[key];
  if (entry) {
    return { ...state, [key]: { ...entry, show } };
  } else {
    return state;
  }
}
